<template>
  <div class="login-container">
    <div class="login-card">
      <div class="login-header">
        <h1 class="app-title">太可智越TechB 家长端</h1>
        <p class="app-subtitle">智能记单词，高效不遗忘</p>
      </div>

      <el-form
        ref="loginForm"
        :model="loginForm"
        :rules="loginRules"
        class="login-form"
        @submit.native.prevent="handleLogin"
      >
        <el-form-item prop="username">
          <el-input
            v-model="loginForm.username"
            prefix-icon="el-icon-user"
            placeholder="请输入用户名"
            size="large"
          />
        </el-form-item>

        <el-form-item prop="password">
          <el-input
            v-model="loginForm.password"
            type="password"
            prefix-icon="el-icon-lock"
            placeholder="请输入密码"
            size="large"
            @keyup.enter.native="handleLogin"
          />
        </el-form-item>

        <el-form-item>
          <el-checkbox v-model="loginForm.rememberMe">记住我</el-checkbox>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            size="large"
            :loading="loginLoading"
            @click="handleLogin"
            class="login-btn"
          >
            {{ loginLoading ? "登录中..." : "登录" }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 备案信息 -->
    <div class="footer-info">
      <p class="copyright-info">
        Copyright © Beijing Taike Nature Education Technology Co., LTD rights reserved.
      </p>
      <p class="icp-info">
        北京太可自然教育科技有限公司
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
          京ICP备2025145356号-1
        </a>
      </p>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "Login",
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
        rememberMe: false,
      },
      loginRules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          {
            min: 3,
            max: 20,
            message: "用户名长度在 3 到 20 个字符",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "密码长度在 6 到 20 个字符",
            trigger: "blur",
          },
        ],
      },
      loginLoading: false,
    };
  },
  methods: {
    ...mapActions("user", ["login"]),

    async handleLogin() {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          this.loginLoading = true;

          try {
            const result = await this.login({
              username: this.loginForm.username,
              password: this.loginForm.password,
              rememberMe: this.loginForm.rememberMe,
            });

            if (result.success) {
              this.$message.success(result.message);
              const redirect =
                this.$route.query.redirect ||
                sessionStorage.getItem("lastRoute") ||
                "/parent/dashboard";
              this.$router.replace(redirect);
            } else {
              this.$message.error(result.message);
            }
          } catch (error) {
            console.error("登录错误:", error);
            this.$message.error("登录失败，请稍后重试");
          } finally {
            this.loginLoading = false;
          }
        } else {
          this.$message.error("请检查输入信息！");
          return false;
        }
      });
    },
  },

  mounted() {
    // 如果记住了用户名，自动填充
    const rememberedUser = localStorage.getItem("rememberedUser");
    if (rememberedUser) {
      this.loginForm.username = rememberedUser;
      this.loginForm.rememberMe = true;
    }
  },
};
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.login-card {
  background: white;
  border-radius: 10px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
  padding: 40px;
  width: 100%;
  max-width: 400px;
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.app-title {
  color: #333;
  font-size: 28px;
  font-weight: bold;
  margin: 0 0 10px 0;
}

.app-subtitle {
  color: #666;
  font-size: 14px;
  margin: 0;
}

.login-form {
  margin-bottom: 20px;
}

.login-btn {
  width: 100%;
  height: 45px;
  font-size: 16px;
}

.demo-account {
  margin-top: 20px;
}

/* 备案信息样式 */
.footer-info {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  line-height: 1.5;
}

.copyright-info {
  margin: 0 0 5px 0;
  color: rgba(255, 255, 255, 0.8);
}

.icp-info {
  margin: 0;
  color: rgba(255, 255, 255, 0.8);
}

.icp-info a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: color 0.3s ease;
}

.icp-info a:hover {
  color: rgba(255, 255, 255, 1);
  text-decoration: underline;
}

/* 响应式设计 */
@media (max-width: 480px) {
  .login-card {
    padding: 30px 20px;
    margin: 0 10px;
  }

  .app-title {
    font-size: 24px;
  }
}
</style>
